import { render } from "./SettingsPage.vue?vue&type=template&id=819dfa64&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=819dfa64&scoped=true&lang=scss"
import "./SettingsPage.vue?vue&type=style&index=1&id=819dfa64&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819dfa64"]])

export default __exports__